// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1070":"css/app.7019","5610":"css/admin-app.7019"}[chunkId] + ".css";
};